import styled from "styled-components";
import theme from "../../theme/theme";
import Tooltip from "../Base/Tooltip";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  .number {
    white-space: nowrap;
    color: ${theme.colors.primaryStrong};
    font-size: 2em;
  }

  .label {
    white-space: nowrap;
    color: ${theme.colors.black};
    letter-spacing: 0px;
    font-size: 0.8em;
  }
`;

const BottomRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;

  .dot {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 10px;
    border: 2px solid #6ac7dd;
    box-sizing: border-box;
  }
`;

const NumberWIthLabelBelow = ({ dotColor, text, label, infoIcon }) => {
  return (
    <Wrapper>
      <span className="number">{text}</span>
      <BottomRow>
        {dotColor && (
          <span className="dot" style={{ backgroundColor: dotColor }}></span>
        )}
        <span className="label">{label}</span>
        {infoIcon && (
          <Tooltip
            text="We believe that the “Max Drawdown” is one of the most important numbers to understand when it comes to investment models. This number is always represented as a negative percentage number.
          Drawdown is a method of measuring downside volatility, a measure of risk. Typically, the closer to 0% Drawdown number, the less model risk when it comes to a market downturn. (As an example, ending on March 9, 2009, during the 2008 financial crisis, the S&P Total Return Index had a drawdown of -55.2 %) Max Drawdown is the largest drawdown that a model has had during a specific time period."
          />
        )}
      </BottomRow>
    </Wrapper>
  );
};

export default NumberWIthLabelBelow;
